module.exports = __webpack_public_path__ + "img/萝芙木.7ac55927.jpg";